<template>
  <section class="section support-section">
    <div class="container">
      <div class="support">
        <h2 class="title title--center support__main-title">Выберите удобный сценарий поддержки:</h2>
        <p class="text text--dark text--center title--mb">самостоятельно или силами нашей команды</p>
        <div class="support__grid">
          <div class="support__block support__block--grey">
            <div class="support__content">
              <nuxt-img src="/img/support/client.png" class="support__img" alt="Поддержка" />
              <div class="support__info">
                <div class="support__header">
                  <h3 class="title title-s4 support__title--grey">Самостоятельно</h3>
                  <div class="support__tag support__tag--grey">Бесплатно</div>
                </div>
                <p class="text text--dark">
                  Вы получаете доступ к новым версиям системы и выполняете обновление силами вашей команды Поддержка без SLA, в общей
                  очереди
                </p>
              </div>
            </div>
            <div class="support__footer">
              <p class="text text--dark support__subtext">Требует тех экспертизы</p>
              <p class="text text--dark support__subtext">Ответственность на вас</p>
            </div>
          </div>
          <div class="support__block support__block--accent">
            <div class="support__content">
              <nuxt-img src="/img/support/support.png" class="support__img" alt="Поддержка" />
              <div class="support__info">
                <div class="support__header">
                  <h3 class="title title-s4 support__title--accent">Поддержка TERPO</h3>
                  <div class="support__tag support__tag--accent">Платно</div>
                </div>
                <p class="text text--dark">
                  Наши специалисты выполняют обновления системы с учетом ваших доработок и интеграций Поддержка по SLA и приоритетная
                  обработка обращений
                </p>
              </div>
            </div>
            <div class="support__footer">
              <p class="text text--dark support__subtext">Без рисков и простоев</p>
              <p class="text text--dark support__subtext">Экономия времени</p>
              <p class="text text--dark support__subtext">Ответственность на нас</p>
            </div>
          </div>
          <div class="support__pic"><nuxt-img class="support__img-bg" src="/img/support/terpo_support.png" /></div>
          <div class="support__sub">
            <h3 class="title title--center title-s4 support__subtitle">Пакеты SLA</h3>
            <div class="support__block support__block--accent support__inner">
              <p class="text text--dark">Обновления системы и приоритетная поддержка в течение срока пакета.</p>
              <a href="/pdf/SLA_TERPO.pdf" download target="_blank" class="button accent-btn">Скачать</a>
            </div>

            <h3 class="title title--center title-s4 support__subtitle">По запросу</h3>
            <div class="support__block support__block--accent support__inner">
              <p class="text text--dark">Обновления системы, консультации и помощь по вашему запросу</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use '~/assets/styles/mixins';

.support {
  &__grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
  }

  &__main-title {
    margin-bottom: 25px;
  }

  &__block {
    border: 2px solid;
    padding: 20px;
    border-radius: 20px;
    background-color: #fff;

    &--grey {
      border-color: #e6e6e6;
    }

    &--accent {
      border-color: var(--accent-color);
    }
  }

  &__subtitle {
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
  }

  &__subtext {
    font-size: 12px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }

  &__tag {
    border-radius: 20px;
    padding: 3px 20px;
    text-align: center;
    font-size: 12px;
    display: flex;
    align-items: center;

    &--accent {
      background-color: #f0edea;
      color: var(--accent-color);
    }

    &--grey {
      background-color: #f3f0f0;
    }
  }

  &__title {
    &--accent {
      color: var(--accent-color);
    }
  }

  &__content {
    display: flex;
    gap: 20px;
    padding-bottom: 20px;
    border-bottom: 2px solid #e6e6e6;
  }

  &__footer {
    display: flex;
    gap: 20px;
    padding-top: 20px;
    flex-wrap: wrap;
  }

  &__img {
    width: 80px;
    height: 80px;
    object-fit: contain;
  }

  &__sub {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    column-gap: 30px;
  }

  &__inner {
    grid-row: 2 / 3;
  }

  &__pic {
    display: flex;
  }

  &__img-bg {
    width: 100%;
    object-fit: contain;
    height: 200px;
  }
}

@media (max-width: 1024px) {
  .support {
    &__grid {
      grid-template-columns: 1fr;
    }
  }
}

@media (max-width: 500px) {
  .support {
    &__img {
      display: none;
    }
  }
}
</style>
